import React from 'react';

const Input = ({ city, setCity, fetchWeather }) => {
  return (
    <div>
      <input
        className='in'
        type='text'
        placeholder='Enter your City'
        value={city}
        onChange={(e) => setCity(e.target.value)} 
      />
      <button className='btn' onClick={fetchWeather}>
        Search
      </button>
    </div>
  );
};

export default Input;

